import {Component, Input} from '@angular/core';

import {SubtitlesService} from "../../core";
import {SystemContainerViewWithId} from "../../models";

@Component({
    selector: 'connection-table',
    templateUrl: './connection-table.component.html',
    styleUrls: ['./connection-table.component.scss']
})
export class ConnectionTableComponent {
    @Input() container: SystemContainerViewWithId;
    @Input() chunk: number;

    constructor(
        private subtitles: SubtitlesService,
    ) {
    }

    subtitle(value: number): string {
        return this.subtitles.setSubtitle(value);
    }
}
